import SideModalProps from "./SideModalProps";
import Component from "vue-class-component";
import LoadingSideModal from "../Loading/LoadingSideModal/LoadingSideModal.vue";
import { bus } from "@/main";

@Component<SideModal>({
  name: "SideModal",

  watch: {
    opened: function (newVal: boolean) {
      this.cx_opened = newVal;
    },
  },

  components: {
    "loading-screen": LoadingSideModal,
  },
})
export default class SideModal extends SideModalProps {
  cx_opened = this.opened;
  cx_loading_enable = false;

  constructor() {
    super();
    this.cx_opened = this.opened;
  }

  mounted() {
    bus.$on("showLoadingSideModal", (state: boolean) => {
      this.cx_loading_enable = state;
    });
  }

  returnResults() {
    if (this.$route.name === "SearchServicesTenancy") {
      this.$router.push({ name: "SearchServicesTenancy" });
    } else if (this.$route.name !== "SearchServices") {
      this.$router.push({ name: "ClinicScreen" });
    }
  }

  closeButton() {
    this.cx_opened = false;
    this.$emit("close", this.cx_opened);
    this.$store.commit("setTime", null);
    this.$emit("closeButton", this.cx_opened);
  }

  closeOutside() {
    this.cx_opened = false;
    this.$emit("close", this.cx_opened);
    this.$emit("closeOutside", this.cx_opened);
  }
}
